import script from "./WelcomeMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeMessage.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeMessage.vue?vue&type=style&index=0&id=ab89424e&lang=css"

const __exports__ = script;

export default __exports__